import { render, staticRenderFns } from "./InsurancePlanForm.vue?vue&type=template&id=1fe3182f&"
import script from "./InsurancePlanForm.vue?vue&type=script&lang=js&"
export * from "./InsurancePlanForm.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePlanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports